import { Link, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { txt } from '../../../services/translation';

export default function SearchButton(){

    const {course} = useParams()

    return course  &&
        <Link to={`/study/${course}/search`}>

            <Button 
                size='small'
                sx={{ml: 1, mt: 2}}
                startIcon={<SearchIcon />}
            >
                {txt('searchButton')}
            </Button>


        </Link>

}